import { defineMessages } from 'react-intl';

export default defineMessages({
    /**
     * Messages used in the *.metadata.json5
     */
    noPoliciesFound: {
        id: 'fnol.producer.common.policy-select-producer.No policies were found that match the search criteria.',
        defaultMessage: 'No policies were found that match the search criteria.'
    },
    dateOfLoss: {
        id: 'fnol.producer.common.policy-select-producer.Date of loss?',
        defaultMessage: 'Date of loss?'
    },
    whenDidLossOccur: {
        id: 'fnol.producer.common.policy-select-producer.When did loss occur?',
        defaultMessage: 'When did loss occur?'
    },
    selectAPolicy: {
        id: 'fnol.producer.common.policy-select-producer.Select a Policy',
        defaultMessage: 'Select a Policy'
    },
    policyNumber: {
        id: 'fnol.producer.common.policy-select-producer.Policy Number',
        defaultMessage: 'Policy Number'
    },
    sasriaPolicyNumber: {
        id: 'fnol.producer.common.policy-select-producer.Sasria Policy Number',
        defaultMessage: 'Insured Policy Number'
    },
    agentClaimNumber: {
        id: 'fnol.producer.common.policy-select-producer.Agent Claim Number',
        defaultMessage: 'Your Claim Number'
    },
    sasriaClassCode: {
        id: 'fnol.producer.common.policy-select-producer.Class Code',
        defaultMessage: 'Class Code'
    },
    policyEffectiveDate: {
        id: 'fnol.producer.common.policy-select-producer.Policy Effective Date',
        defaultMessage: 'Policy Effective Date'
    },
    policyExpiryDate: {
        id: 'fnol.producer.common.policy-select-producer.Policy Expiry Date',
        defaultMessage: 'Policy Expiry Date'
    },
    policyNumberPlaceholder: {
        id: 'fnol.producer.common.policy-select-producer.Start Typing',
        defaultMessage: 'Start Typing'
    },
    search: {
        id: 'fnol.producer.common.policy-select-producer.Search',
        defaultMessage: 'Search'
    },
    dontHaveYourPolicyNumber: {
        id: 'fnol.producer.common.policy-select-producer.Dont have your policy number?',
        defaultMessage: 'Don\'t have your policy number?'
    },
    noPoliciesFoundThatMatchTheSearchCriteria: {
        id: 'fnol.producer.common.policy-select-producer.No policies were found that match the search criteria',
        defaultMessage: 'No policies were found that match the search criteria'
    },
    /**
     * Messages shown on the Modal when a user triggers a policy change
     */
    changePolicyModalTitle: {
        id: 'fnol.producer.common.policy-select-producer.Policy change',
        defaultMessage: 'Policy change'
    },
    changePolicyModalMessage: {
        id: 'fnol.producer.common.policy-select-producer.You have selected a new policy for this claim. The data you have entered for this claim will be lost.',
        defaultMessage: 'You have selected a new policy for this claim. The data you have entered for this claim will be lost.'
    },
    changePolicyModalConfirmationButtonText: {
        id: 'fnol.producer.common.policy-select-producer.Change Policy',
        defaultMessage: 'Change Policy'
    },
    changePolicyModalCancelButtonText: {
        id: 'fnol.producer.common.policy-select-producer.Cancel',
        defaultMessage: 'Cancel'
    },
    insuredId: {
        id: 'fnol.common.policy-select-insured.Insured',
        defaultMessage: 'Insured'
    },
    insuredPlaceHolder: {
        id: 'fnol.common.policy-select-insured.Insured Name / Insured Company',
        defaultMessage: 'Insured Name / Insured Company'
    },
    dontHaveId: {
        id: 'fnol.common.policy-select-insured.Search for an Insured',
        defaultMessage: 'Search for an Insured'
    },
    search: {
        id: 'fnol.common.policy-select-insured.Search',
        defaultMessage: 'Search'
    },

    search: {
        id: 'fnol.common.policy-select-insured.Create',
        defaultMessage: 'Create'
    },

    searchInsuredTitle: {
        id: 'fnol.common.policy-select-insured.Select an Insured',
        defaultMessage: 'Select an Insured'
    },
    searchPerson: {
        id: 'fnol.common.policy-select-insured.Person',
        defaultMessage: 'Person'
    },
    searchCompany: {
        id: 'fnol.common.policy-select-insured.Company',
        defaultMessage: 'Company'
    },
    searchCompany: {
        id: 'fnol.common.policy-select-insured.SA ID',
        defaultMessage: 'SA ID'
    },
    searchCompany: {
        id: 'fnol.common.policy-select-insured.Passport',
        defaultMessage: 'Passport'
    },

    companyName: {
        id: 'fnol.common.policy-select-insured.CompanyName',
        defaultMessage: 'Company Name'
    },

    companyVAT: {
        id: 'fnol.common.policy-select-insured.CompanyVAT',
        defaultMessage: 'VAT Number'
    },

    companyReg: {
        id: 'fnol.common.policy-select-insured.CompanyReg',
        defaultMessage: 'Company Reg Number'
    },

    firstName: {
        id: 'fnol.common.policy-select-insured.First Name',
        defaultMessage: 'First Name'
    },

    lastName: {
        id: 'fnol.common.policy-select-insured.Last Name',
        defaultMessage: 'Last Name'
    },

    vatNoValidationTitle: {
        id: 'fnol.common.policy-select-insured.VatNoValidation',
        defaultMessage: 'VAT No validation has failed'
    },
    vatNoValidationMessage: {
        id: 'nol.common.policy-select-insured.VatNoValidationMessage.',
        defaultMessage: 'The  VAT No should contain 10 digits with all numeric values.'
    },

    errorCreatingInsuredTitle: {
        id: 'fnol.common.policy-select-insured.errorCreatingInsuredTitle',
        defaultMessage: 'Insured has not been created'
    },
    errorCreatingInsuredMessage: {
        id: 'nol.common.policy-select-insured.errorCreatingInsuredMessage.',
        defaultMessage: 'There are problems creating insured.Please check the inputs and try again'
    },
    regNoValidationTitle: {
        id: 'fnol.common.policy-select-insured.RegnoValidation',
        defaultMessage: 'Registration No validation has failed'
    },
    regNoValidationMessage: {
        id: 'nol.common.policy-select-insured.RegNoValidationMessage.',
        defaultMessage: 'Registration Number should be in Digits or YYYY/NNNNNN/NN Format.'
    },

    idNoValidationTitle: {
        id: 'fnol.common.policy-select-insured.idNoValidationTitle',
        defaultMessage: 'Identity Number validation has failed'
    },
    idNoValidationMessage: {
        id: 'nol.common.policy-select-insured.idNoValidationMessage.',
        defaultMessage: 'Identity Number must be 13 digit numeric number with no spaces.'
    },
    passportNoValidationTitle: {
        id: 'fnol.common.policy-select-insured.passportNoValidationTitle',
        defaultMessage: 'Passport Number validation has failed'
    },
    passportNoValidationMessage: {
        id: 'nol.common.policy-select-insured.passportNoValidationMessage.',
        defaultMessage: 'Passport Number must be upto 13 digits aplha numeric with no spaces.'
    },

    vatNoMandatoryTitle: {
        id: 'fnol.common.policy-select-insured.vatNoMandatoryTitle',
        defaultMessage: 'VAT No is mandatory'
    },
    vatNoMandatoryMessage: {
        id: 'nol.common.policy-select-insured.vatNoMandatoryMessage.',
        defaultMessage: 'VAT No is mandatory if VAT Registered is selected as Yes.'
    },

    errorSearchingInsuredTitle: {
        id: 'fnol.common.policy-select-insured.errorSearchingInsuredTitle',
        defaultMessage: 'Insured has not been searched'
    },
    errorSearchingInsuredMessage: {
        id: 'nol.common.policy-select-insured.errorSearchingInsuredMessage.',
        defaultMessage: 'There are problems searching insured.Please check the inputs and try again'
    },

    addressMandatoryTitle: {
        id: 'fnol.common.policy-select-insured.addressMandatoryTitle',
        defaultMessage: 'City and Country is mandatory'
    },
    addressMandatoryMessage: {
        id: 'nol.common.policy-select-insured.addressMandatoryMessage.',
        defaultMessage: 'Please specify city and Country for creating insured.'
    },
    duplicateClaimsFound: {
        id: 'fnol.common.claim.DuplicateClaimsFound',
        defaultMessage: 'There are possible duplicate claims already existing based on the details you have entered. You may proceed, however Express Claim option will not be available.'
    }
});
